import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { to2 } from '../../../utils/utils';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import Button from '../../shared/atoms/Button';
import Separator from '../../Separator';
import Alert from '../../shared/molecules/Alert';

// Icons
import User16 from '../../icons/User16';
import Message16 from '../../icons/Message16';

const BuyGiftCardConfirmation = ({ giftcard }) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Alert status="success" mb={6}>
        {t('buygcardconfirmation.texts.1')}
      </Alert>
      <Box
        borderColor="gray.light"
        borderWidth="1px"
        borderRadius="xs"
        borderStyle="solid"
        p={4}>
        <Box flexDirection="row">
          <Text mr={1}>{t('dated')} :</Text>
          <Text color="black">
            {moment(giftcard.created_at).format('DD/MM/YYYY [à] HH[h]mm')}
          </Text>
        </Box>
        <Separator axe="horizontal" my={4} />
        <Box flexDirection={{ xs: 'column', sm: 'row' }}>
          <img
            style={{ objectFit: 'contain', marginRight: 16 }}
            width={150}
            height={95}
            src={`/static/img/pictos/giftcard/roulez-jeunesse-card-${giftcard.giftcardChoice}.png`}
          />
          <Box mt={{ xs: 3, sm: 0 }}>
            <Text fontSize="lg" fontWeight={2}>
              {t('buygcardconfirmation.texts.2', {
                amount: giftcard.customAmount
                  ? giftcard.customAmount
                  : giftcard.creditedAmount,
              })}
            </Text>
            <Box flexDirection="row" mt={2}>
              <User16 mr={1} mt={1} />
              <Text>{giftcard.recipientName}</Text>
            </Box>
            <Box flexDirection="row">
              <Message16 mr={1} mt={1} />
              <Text color={giftcard.message ? null : 'gray.dark'}>
                {giftcard.message
                  ? giftcard.message
                  : t('buygiftcardrecap.texts.2')}
              </Text>
            </Box>
          </Box>
        </Box>
        <Separator axe="horizontal" my={4} />
        <Box flexDirection="row" justifyContent="space-between">
          <Text>{t('coursebill.text.5')}</Text>
          <Text>{to2(giftcard.amount - giftcard.amount * 0.2)}€</Text>
        </Box>
        <Box flexDirection="row" justifyContent="space-between" mt={2}>
          <Text>{t('vat.twenty')}</Text>
          <Text>{to2(giftcard.amount * 0.2)}€</Text>
        </Box>
        <Separator axe="horizontal" my={4} />
        <Box flexDirection="row" justifyContent="space-between">
          <Text color="black">{t('total')}</Text>
          <Text color="black" fontWeight={2} fontSize="lg">
            {to2(giftcard.amount)}
            {t('€')}
          </Text>
        </Box>
      </Box>
      <Box alignSelf="flex-end" mt={4}>
        <Button to="/">{t('buycardconfirmation.cta')}</Button>
      </Box>
    </Box>
  );
};

export default BuyGiftCardConfirmation;
